{
    "PAYMENT_OK_TITLE": "¡Pago realizado correctamente!",
    "PAYMENT_OK_DESCRIPTION": "Tu pago se ha completado correctamente. Te hemos enviado un justificante del pago a tu correo electrónico junto con los términos y condiciones del servicio.",
    "RETURN_HOME": "Volver al inicio",
    "PAYMENT_KO_TITLE": "¡Ha ocurrido un error!",
    "PAYMENT_KO_DESCRIPTION": "No se ha podido completar el pago y no se te ha cobrado nada. Puedes volver a intentarlo.",
    "RETRY": "Reintentar"
}